/* ═══════════════════════════════════════════
   RISE Pilot Contest — SVG 아이콘 세트
   
   토스 디자인 원칙: 이모지 남용 금지 (whatquiz-design §4, §626)
   모든 아이콘은 stroke 기반 라인 아이콘으로 통일 (24x24 기준)
   ═══════════════════════════════════════════ */

import React from 'react';

const baseProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/** 트로피 (대상 / 수상작) */
export const TrophyIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M6 9H4.5a2.5 2.5 0 010-5H6"/>
    <path d="M18 9h1.5a2.5 2.5 0 000-5H18"/>
    <path d="M4 22h16"/>
    <path d="M10 22v-4h4v4"/>
    <path d="M8 14.6V3h8v11.6a4 4 0 01-8 0z"/>
  </svg>
);

/** 메달 (우수/장려상) */
export const MedalIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M7.21 3H16.79L20 8.5L12 21L4 8.5L7.21 3z"/>
    <circle cx="12" cy="14" r="4"/>
  </svg>
);

/** 선물 (참여상) */
export const GiftIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="3" y="8" width="18" height="4" rx="1"/>
    <path d="M12 8v13"/>
    <path d="M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"/>
    <path d="M7.5 8a2.5 2.5 0 010-5c1.886 0 3 1.5 4.5 5 1.5-3.5 2.614-5 4.5-5a2.5 2.5 0 010 5"/>
  </svg>
);

/** 타겟 (참여 방법 1단계) */
export const TargetIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

/** 연필 (참여 방법 2단계) */
export const PencilIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z"/>
  </svg>
);

/** 보내기 (참여 방법 3단계) */
export const SendIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M22 2L11 13"/>
    <path d="M22 2l-7 20-4-9-9-4 20-7z"/>
  </svg>
);

/** 하트 (좋아요, 선) */
export const HeartIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
  </svg>
);

/** 하트 채워진 (좋아요 눌린 상태) */
export const HeartFillIcon = (props) => (
  <svg {...baseProps} fill="currentColor" stroke="currentColor" strokeWidth="0" {...props}>
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
  </svg>
);

/** 투표 (투표하러 가기 CTA) */
export const VoteIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M9 11l3 3L22 4"/>
    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
  </svg>
);

/** 문서 (작품 제출 CTA) */
export const DocumentIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
);

/** 별 (수상작 보기 CTA) */
export const StarIcon = (props) => (
  <svg {...baseProps} {...props}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

/** 다운로드 */
export const DownloadIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

/** 업로드 */
export const UploadIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/>
    <line x1="12" y1="3" x2="12" y2="15"/>
  </svg>
);

/** 경고 */
export const WarningIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

/** 체크 */
export const CheckIcon = (props) => (
  <svg {...baseProps} {...props}>
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

/** 체크 동그라미 (상태 OK) */
export const CheckCircleIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

/** 달력 */
export const CalendarIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

/** 차트 바 */
export const BarChartIcon = (props) => (
  <svg {...baseProps} {...props}>
    <line x1="12" y1="20" x2="12" y2="10"/>
    <line x1="18" y1="20" x2="18" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="16"/>
  </svg>
);

/** 화살표 오른쪽 */
export const ArrowRightIcon = (props) => (
  <svg {...baseProps} {...props}>
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

/** 화살표 왼쪽 */
export const ArrowLeftIcon = (props) => (
  <svg {...baseProps} {...props}>
    <line x1="19" y1="12" x2="5" y2="12"/>
    <polyline points="12 19 5 12 12 5"/>
  </svg>
);

/** 닫기 */
export const CloseIcon = (props) => (
  <svg {...baseProps} {...props}>
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

/** 더하기 (FAQ 펼치기) */
export const PlusIcon = (props) => (
  <svg {...baseProps} {...props}>
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

/** 빼기 (FAQ 접기) */
export const MinusIcon = (props) => (
  <svg {...baseProps} {...props}>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

/** 이미지 (작품 썸네일 fallback) */
export const ImageIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <polyline points="21 15 16 10 5 21"/>
  </svg>
);

/** 돋보기 (검색) */
export const SearchIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

/** 북마크 (따라해볼래요 · 당근마켓 관심 패턴) */
export const BookmarkIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z"/>
  </svg>
);

/** 북마크 채워짐 */
export const BookmarkFillIcon = (props) => (
  <svg {...baseProps} fill="currentColor" stroke="currentColor" strokeWidth="0" {...props}>
    <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z"/>
  </svg>
);

/** 공유 (URL 복사) */
export const ShareIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="18" cy="5" r="3"/>
    <circle cx="6" cy="12" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

/** 말풍선 (댓글) */
export const MessageIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);

/** 엄지업 (도움이 돼요 · 쿠팡 패턴) */
export const ThumbsUpIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3"/>
  </svg>
);

/** 엄지업 채워짐 */
export const ThumbsUpFillIcon = (props) => (
  <svg {...baseProps} fill="currentColor" stroke="currentColor" strokeWidth="0" {...props}>
    <path d="M2 20h2c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2H2v11zM22 11a2 2 0 00-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L13.17 2 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1z"/>
  </svg>
);

/**
 * 학교급별 대표 아이콘
 * 썸네일 그라디언트 남용을 피하기 위해 학교급만 구분
 */
export const GradeIcon = ({ gradeGroup, ...props }) => {
  if (gradeGroup === 'elementary') {
    return (
      <svg {...baseProps} {...props}>
        <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/>
        <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/>
      </svg>
    );
  }
  if (gradeGroup === 'middle') {
    return (
      <svg {...baseProps} {...props}>
        <path d="M12 20h9"/>
        <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z"/>
      </svg>
    );
  }
  if (gradeGroup === 'high') {
    return (
      <svg {...baseProps} {...props}>
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
        <path d="M6 12v5c3 3 9 3 12 0v-5"/>
      </svg>
    );
  }
  if (gradeGroup === 'special') {
    return (
      <svg {...baseProps} {...props}>
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8v4l3 3"/>
      </svg>
    );
  }
  return null;
};
